/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Select_Event_Group_PromptInputs */



/**
* | output |
* | --- |
* | "Please select an Event Group from the top navbar" |
*
* @param {Editor_Select_Event_Group_PromptInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_select_event_group_prompt = /** @type {((inputs?: Editor_Select_Event_Group_PromptInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Select_Event_Group_PromptInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Veuillez selectionner un groupe d'evenements dans la barre de navigation superieure")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bitte wählen Sie eine Veranstaltungsgruppe aus der oberen Navigationsleiste aus.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona un gruppo di eventi dalla barra di navigazione in alto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пожалуйста, выберите группу событий в верхней панели навигации.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccione un grupo de eventos en la barra de navegación superior")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("请从顶部导航栏选择一个活动组")
	if (locale === "ja") return /** @type {LocalizedString} */ ("上部のナビゲーションバーからイベントグループを選択してください")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कृपया शीर्ष नेविगेशन बार से एक इवेंट समूह चुनें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione um Grupo de Eventos na barra de navegação superior.")
	return /** @type {LocalizedString} */ ("Please select an Event Group from the top navbar")
});